import {
    localSave,
    localRead
} from './lang';
import i18n from '@/plugins/i18n';
import dbAddress from "@/plugins/db-thai-address/db.json";
export default {
    state: {
        local: localRead('local'),
    },
    mutations: {
        setLocal(state, lang) {
            localSave('local', lang);
            state.local = lang;
        },
        vueTableFormatJson(restData) {
            let jsonData = restData.data;
            let data = [];
            for (let [k, v] of Object.entries(jsonData)) {
                switch (k) {
                    case 'links':
                        let link = []
                        for (let [k_link, v_link] of Object.entries(v)) {
                            link[k_link + '_page_url'] = v_link
                        }
                        data = {...data, ...link };
                        break;
                    case 'meta':
                        data = {...data, ...v };
                        break;
                    case 'data':
                        data = {...data, ... { data: v } };
                        break;
                    default:
                        data[k] = {...data[k], ...v };
                }
            }
            return data;
        }
    },

    getImage(file_name) {
        var image = require('@/assets/images/no-image.png');
        try {
            image = '<img src="' + this.getImageSrc(file_name) + '" width="24">';
        } catch (error) {
            console.log(error, 'error');
        }
        return image;
    },
    getImageSrc(file_name) {
        let images = require('@/assets/images/no-image.png');
        try {
            images = require('@/assets/images/' + file_name + '.png');
            // images = require('@/assets/images/COD.png');
        } catch (err) {
            // console.log(file_name, 'getImageGobalAssets error');
        }
        return images
    },
    getImageGobalAssets(file_name) {
        let images = require('@/assets/images/no-image.png');
        try {
            images = require('@/assets/global_assets/images/' + file_name + '.png');
        } catch (err) {
            console.log(file_name, 'getImageGobalAssets error');
        }
        return images

    },
    isset(accessor) {
        try {
            // Note we're se
            return typeof accessor() !== 'undefined'
        } catch (e) {
            return false
        }
    },

    monthNames() {
        return [i18n.t("Jan"), i18n.t("Feb"), i18n.t("Mar"), i18n.t("Apr"), i18n.t("May"), i18n.t("Jun"), i18n.t("Jul"), i18n.t("Aug"), i18n.t("Sep"), i18n.t("Oct"), i18n.t("Nov"), i18n.t("Dec"), i18n.t("January"), i18n.t("February"), i18n.t("March"), i18n.t("April"), i18n.t("May"), i18n.t("June"), i18n.t("July"), i18n.t("August"), i18n.t("September"), i18n.t("October"), i18n.t("November"), i18n.t("December")].slice(0, 12);
    },
    
    daysOfWeek(){
        return [i18n.t("Sun"), i18n.t("Mon"), i18n.t("Tue"), i18n.t("Wed"), i18n.t("Thu"), i18n.t("Fri"), i18n.t("Sat"), i18n.t("Sunday"), i18n.t("Monday"), i18n.t("Tuesday"), i18n.t("Wednesday"), i18n.t("Thursday"), i18n.t("Friday"), i18n.t("Saturday")].slice(0, 7).map((function(t) {
            return t.substring(0, 2)
        }))
    },

    ranges(){
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        let todayEnd = new Date()
        todayEnd.setHours(11, 59, 59, 999);

        let yesterdayStart = new Date()
        yesterdayStart.setDate(today.getDate() - 1)
        yesterdayStart.setHours(0, 0, 0, 0);

        let yesterdayEnd = new Date()
        yesterdayEnd.setDate(today.getDate() - 1)
        yesterdayEnd.setHours(11, 59, 59, 999);

        let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);
        
        const _default_ranges ={
            'Today': [today, todayEnd],
            'Yesterday': [yesterdayStart, yesterdayEnd],
            'This month': [thisMonthStart, thisMonthEnd],
            'This year': [
                new Date(today.getFullYear(), 0, 1),
                new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
            ],
            'Last month': [
                new Date(today.getFullYear(), today.getMonth() - 1, 1),
                new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
            ],
            'Last year': [
                new Date(today.getFullYear() - 1, 0, 1),
                new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)
            ],
        }

        let _ranges = [];
        for (const [key, value] of Object.entries(_default_ranges)) {
            _ranges[i18n.t(key)] = value;
        }
        return Object.assign({}, _ranges);

    },
    getCarrierCode(integration_type_id){
        var carrier_code = '';
        switch (integration_type_id.toString()) {
            case '4':
                carrier_code = 'KERRY_EXPRESS';
                break;
            case '5':
                carrier_code = 'THAIPOST';
                break;
            case '6':
                carrier_code = 'FLASH_EXPRESS';
                break;
            case '8':
                carrier_code = 'J&T_EXPRESS';
                break;
            default:
                carrier_code = '-';
                break;
        }
        return carrier_code;
    },
    issetObjectKey(setDefault,param,key,digits = 0, turnBoolean = false) {
        let trunData = setDefault;
        if(param) {
          if(
            Object.keys(param).includes(key) && param[key] ||
            Object.keys(param).includes(key) && !isNaN(parseFloat(param[key]))
          ) {
            if(turnBoolean) {
              trunData = (param[key] || param[key].toString() == '1') ? true : false;
            } else {
              trunData = !isNaN(parseFloat(param[key])) ? Number(parseFloat(param[key]).toFixed(digits)) : param[key];
            }
          }
        }
        return trunData;
    },
    async provinceData(){ 
        let provincesData = dbAddress

        let lookup = [];
        let words = [];
        let expanded = [];
        let t;
        let data = [];

        lookup = provincesData.lookup.split('|');
        words = provincesData.words.split('|');
        data = provincesData.data;
        t = function (text) {
        function repl(m) {
            var ch = m.charCodeAt(0);
            return words[ch < 97 ? ch - 65 : 26 + ch - 97];
        }
        if (typeof text === 'number') {
            text = lookup[text];
        }
        return text.replace(/[A-Z]/ig, repl);
        };
        data.map(function (provinces) {
        var i = 1;
        if(provinces.length === 3){ // geographic database
            i = 2;
        }
        var entry = t(provinces[0]);
        if(i === 2){ // geographic database
            entry = provinces[1] || false;
        }
        expanded.push(entry);
        });
        // provincesList = expanded 
        return expanded
    },
};



// WEBPACK FOOTER //
// ./src/store/index.js